/**
 * Ordem das pastas no gerenciador.
 *
 * A favorita vem antes das outras em qualquer ordenação — decisão do dono —,
 * e dentro de cada grupo vale a ordem escolhida: nome, ou a mais recente
 * primeiro com o nome de desempate.
 */

export interface OrderableFolder {
  name: string;
  created_at?: string | null;
  favorite?: boolean;
}

export type FolderSortOrder = "uploaded" | "name";

function createdMs(folder: OrderableFolder): number {
  if (!folder.created_at) return Number.NEGATIVE_INFINITY;
  const timestamp = Date.parse(folder.created_at);
  return Number.isFinite(timestamp) ? timestamp : Number.NEGATIVE_INFINITY;
}

function compareName(a: OrderableFolder, b: OrderableFolder): number {
  return a.name.localeCompare(b.name, "pt-BR", { numeric: true, sensitivity: "base" });
}

export function compareFolders(
  a: OrderableFolder,
  b: OrderableFolder,
  sortOrder: FolderSortOrder,
): number {
  const favorite = Number(b.favorite === true) - Number(a.favorite === true);
  if (favorite !== 0) return favorite;
  if (sortOrder === "name") return compareName(a, b);
  // Duas sem data dão NaN na subtração, que é falso: o nome desempata.
  return createdMs(b) - createdMs(a) || compareName(a, b);
}

export function sortFolders<T extends OrderableFolder>(folders: readonly T[], sortOrder: FolderSortOrder): T[] {
  return [...folders].sort((a, b) => compareFolders(a, b, sortOrder));
}
